import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import * as TranslationsNL from '../assets/i18n/nl.json';
import * as TranslationsDE from '../assets/i18n/de.json';
import * as TranslationsEN from '../assets/i18n/en.json';

interface Translation {
    [key: string]: any;
}

const TRANSLATIONS: Translation = {
    nl: TranslationsNL,
    en: TranslationsEN,
    de: TranslationsDE,
};

export class StaticTranslationLoader implements TranslateLoader {
    public getTranslation(lang: string): Observable<any> {
        const translation = TRANSLATIONS[lang];
        if (translation) {
            return of(translation);
        } else {
            console.error(`Unknown language: ${lang}`);
            return of({});
        }
    }
}